<div (click)="routingService.open(url())"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    @if (loading()) {
        <lib-loading-placeholder [show]="loading()"/>
    } @else {
        <div class=" d-flex justify-content-between">
            <div class=" fs-main fw-bold mb-3">{{ title() }}</div>
            <div class=" mt-auto mb-auto">
                <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
            </div>
        </div>
        <div class="row">
            @if (unknown().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-animal-svg
                            [animalType]="AnimalType.UNKNOWN"
                            [height]="'25px'"
                            [width]="'25px'"
                            class="img-fluid img-max m-auto"></app-animal-svg>
                    <span class="m-2"> {{ unknown().length }} </span>
                </div>
            }
            @if (cows().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-animal-svg
                            [animalType]="AnimalType.COW"
                            [height]="'25px'"
                            [width]="'25px'"
                            class="img-fluid img-max m-auto"></app-animal-svg>
                    <span class="m-2"> {{ cows().length }} </span>
                </div>
            }
            @if (bulls().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-animal-svg
                            [animalType]="AnimalType.BULL"
                            [height]="'25px'"
                            [width]="'25px'"
                            class="img-fluid img-max m-auto"></app-animal-svg>
                    <span class="m-2"> {{ bulls().length }} </span>
                </div>
            }
            @if (calves().length > 0) {
                <div class="col-auto  ps-2 pe-0">
                    <app-animal-svg
                            [animalType]="AnimalType.HEIFER_WEANER"
                            [height]="'25px'"
                            [width]="'25px'"
                            class="img-fluid img-max m-auto"></app-animal-svg>
                    <span class="m-2"> {{ calves().length }} </span>
                </div>
            }
            @if (steers().length > 0) {
                <div class="col-auto  ps-2 pe-0">
                    <app-animal-svg
                            [animalType]="AnimalType.STEER"
                            [height]="'25px'"
                            [width]="'25px'"
                            class="img-fluid img-max m-auto"></app-animal-svg>
                    <span class="m-2"> {{ steers().length }} </span>
                </div>
            }
        </div>
    }
</div>
